module.exports = __webpack_public_path__ + "img/menu.4b5659b8.svg";